<app-admin-access-users-list [groups]="groups" [(selectedUserGroups)]="selectedGroups"></app-admin-access-users-list>
